// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"72":"0d4b57787fe127b12ffa","562":"4cb17eda9dde4415025f","665":"691967371a2e49e7a11e","938":"3c87e5f275a4cf84a4a3"}[chunkId] + ".js";
};